import { render, staticRenderFns } from "./TgPicPanel.vue?vue&type=template&id=051fe266&"
import script from "./TgPicPanel.vue?vue&type=script&lang=js&"
export * from "./TgPicPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports